import isCpfvalid from './isCpfValid';

export default function hideCpf(cpf?: string): string {
  if (!cpf) return '';
  if (!isCpfvalid(cpf)) return '';
  return `•••.•••.${cpf?.slice(8, 16)}`;
}
